import { Paper, Select, MenuItem, Button, Grid, InputLabel, withStyles, Snackbar, SnackbarContent, FormControl } from '@material-ui/core';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import TitleToolbar from '../../Forms/TitleToolbar';
import { reportTypes, styleWithCommonClasses } from '../../../_constants/emparkConstants';
import translate from '../../../locales';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';

import OutlinedTextField from '../../OutlinedTextField';
import EMTable from '../../Tables/EMTable';
import DatePicker from "react-datepicker";
import moment from 'moment';
import { deleteReport, downloadFileFromResponse, downloadReport, generateReport, getReports } from '../../../services';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import ErrorIcon from '@material-ui/icons/Error';
import DeleteIcon from '@material-ui/icons/Delete';
import RefreshIcon from '@material-ui/icons/Refresh';
import { jsonDateFormat, jsonDateTimeFormat, stringToDate, toDateJsonString, toDateObject, toDateString, toDateTimeString } from '../../../_helpers/dateConvert';
import OkDialog from '../../Dialogs/OkDialog';
import ConfirmDialog from '../../Dialogs/ConfirmDialog';
import LoadingDialog from '../../Dialogs/LoadingDialog';

const __t = translate;

const styles = styleWithCommonClasses({
    select: {
        marginLeft: '20px'
    }
});

const ReportsPage = (props) => {
    const { classes } = props;

    const [reportType, setReportType] = useState(reportTypes.ALL_OFF_ROT);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [error, setError] = useState(null);

    const [filter, setFilter] = useState(null);
    const [reportQuery, setReportQuery] = useState({
        loading: true,
        data: null,
        error: null
    });

    const fetchReports = useCallback(() => {
        getReports()
            .then((responseData) => {
                console.log(responseData);
                setReportQuery({ loading: false, data: responseData, error: null });
            })
            .catch((error) => {
                console.error('Error fetching reports:', error);
                setReportQuery({ loading: false, data: null, error });
            });
    }, []);

    useEffect(() => {
        fetchReports();
    }, []);

    useEffect(() => {
        let interval = null;
        if (reportQuery.data != null && reportQuery.data.some(r => r.status === 'generating')) {
            interval = setInterval(() => {
                fetchReports();
            }, 15000);
        }

        return () => {
            if (interval != null) {
                clearInterval(interval);
            }
        }

    }, [fetchReports, reportQuery.data]);

    const reports = reportQuery.loading || reportQuery.error ?
        []
        :
        filter != null ?
            reportQuery.data.filter(r => r.reportType == filter.reportType && r.fromDate == toDateJsonString(filter.fromDate) && r.toDate == toDateJsonString(filter.toDate))
            :
            reportQuery.data;

    return (
        <div>
            <Paper
                className={classes.paper}
                style={{ marginTop: '100px' }}
                elevation={0}
            >
                <TitleToolbar
                    title={`${__t('filter')}`}
                >
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Grid container alignItems="center">
                                <Grid xs={2} item>
                                    <InputLabel shrink required>{__t('report')}:</InputLabel>
                                </Grid>
                                <Grid xs={4} item>
                                    <FormControl variant="filled" style={{ border: '1px solid #c4c4c4', borderRadius: '4px', paddingTop: '4px', paddingBottom: '4px' }}>
                                        <Select
                                            className={classes.select}
                                            value={reportType}
                                            onChange={(e) => setReportType(e.target.value)}
                                            variant="outlined"
                                        >
                                            <MenuItem value={reportTypes.ALL_OFF_ROT}>{__t('report_title_all_off_rot')}</MenuItem>
                                            <MenuItem value={reportTypes.ALL_OFF_MULPASS}>{__t('report_title_all_off_mul')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid xs={6}>

                                </Grid>
                                <Grid xs={2} item style={{ marginTop: '20px' }}>
                                    <InputLabel shrink required>{__t('from')} {__t('inclusive_helper')}:</InputLabel>
                                </Grid>
                                <Grid xs={4} item style={{ marginTop: '20px' }}>
                                    <DatePicker
                                        locale={'es'}
                                        selected={fromDate}
                                        dateFormat="dd/MM/yyyy"
                                        todayButton={__t("today_label")}
                                        disabledKeyboardNavigation
                                        onChange={(date) => {
                                            setError(null);
                                            setFromDate(date)
                                        }}
                                        customInput={
                                            <OutlinedTextField
                                                readOnly={true}
                                                hideLabel={true}
                                            />
                                        }
                                    />
                                </Grid>

                                <Grid xs={2} item style={{ marginTop: '20px' }}>
                                    <InputLabel shrink required>{__t('to')} {__t('exclusive_helper')}:</InputLabel>
                                </Grid>
                                <Grid xs={4} item style={{ marginTop: '20px' }}>
                                    <DatePicker
                                        locale={'es'}
                                        selected={toDate}
                                        dateFormat="dd/MM/yyyy"
                                        todayButton={__t("today_label")}
                                        disabledKeyboardNavigation
                                        onChange={(date) => {
                                            setError(null);
                                            setToDate(date);
                                        }}
                                        customInput={
                                            <OutlinedTextField
                                                readOnly={true}
                                                hideLabel={true}
                                            />
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px' }}>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => {
                                    if (!fromDate || !toDate) {
                                        setError(__t('report_filter_error_missing_fields'));
                                        return;
                                    }

                                    if (fromDate >= toDate) {
                                        setError(__t('report_filter_error_dates'));
                                        return;
                                    }

                                    setFilter({
                                        reportType,
                                        fromDate,
                                        toDate
                                    });
                                }}>
                                {__t('search')}
                            </Button>

                            <Button
                                style={{ marginLeft: '15px' }}
                                variant="outlined"
                                color="primary"
                                onClick={() => {
                                    setFilter(null);
                                    setFromDate('');
                                    setToDate('');
                                }}>
                                {__t('clean')}
                            </Button>
                        </div>
                        {error != null ?
                            <div style={{ textAlign: 'center', color: 'red', marginTop: '10px' }}>
                                {error}
                            </div>
                            :
                            null
                        }

                    </div>
                </TitleToolbar>
            </Paper>

            <Paper
                className={classes.paper}
                style={{ marginTop: '24px' }}
                elevation={0}
            >
                {reportQuery.loading ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress />
                    </div>
                    :
                    <ReportPageTable
                        filter={filter}
                        reports={reports}
                        fetchReports={fetchReports}
                    />
                }
            </Paper>
        </div>
    );
};

const ReportPageTable = (props) => {
    const [loadingGenerate, setLoadingGenerate] = useState(false);
    const [reportError, setReportError] = useState(null);
    const [deleteReportRow, setDeleteReportRow] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const columnDefinition = [
        {
            id: 'fromDate', align: 'center', disablePadding: false, label: __t('from'), formatter: function (value) {
                console.log('fromDate', value);
                return toDateString(stringToDate(value, jsonDateFormat));
            }
        },
        {
            id: 'toDate', align: 'center', disablePadding: false, label: __t('to'), formatter: function (value) {
                console.log('toDate', value);
                return toDateString(stringToDate(value, jsonDateFormat));
            }
        },
        {
            id: 'completedDate', align: 'center', disablePadding: false, label: __t('generated_date'), formatter: function (value) {
                return value ? toDateTimeString(stringToDate(value.replace('T', ' '), jsonDateTimeFormat)) : '';
            }
        },
        { id: 'insUser', align: 'center', disablePadding: false, label: __t('user') },
        {
            id: 'status', align: 'center', disablePadding: false, label: __t('status'), formatter: function (value, rowData) {
                console.log('rowData', rowData)
                if (value == 'generating')
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <IconButton
                                style={{ size: 'small', cursor: 'default' }}
                            >
                                <CircularProgress size={20} />
                            </IconButton>

                            <IconButton
                                style={{ size: 'small', color: 'red', marginLeft: '8px' }}
                                onClick={() => {
                                    setDeleteReportRow(rowData);
                                }}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </div>
                    );

                if (value == 'completed')
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <IconButton
                                style={{ size: 'small' }}
                                onClick={async () => {
                                    setLoading(true);

                                    try {
                                        const response = await downloadReport(rowData.id);
                                        if (response.status != 200) {
                                            console.error(response);
                                            throw new Error('Failed to download report');
                                        }

                                        downloadFileFromResponse(response);
                                    } catch (error) {
                                        setMessage({ isError: true, text: __t('error_downloading_report') })
                                        console.error('Error downloading report:', error);
                                    }

                                    setLoading(false);
                                }}
                            >
                                <CloudDownloadIcon />
                            </IconButton>

                            <IconButton
                                style={{ size: 'small', color: 'red', marginLeft: '8px' }}
                                onClick={() => {
                                    setDeleteReportRow(rowData);
                                }}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </div>);

                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <IconButton
                            style={{ color: 'red', size: 'small' }}
                            onClick={() => {
                                setReportError(rowData.error);
                            }}
                        >
                            <ErrorIcon />
                        </IconButton>
                        <IconButton
                            style={{ color: 'red', size: 'small', marginLeft: '8px' }}
                            onClick={() => {
                                setDeleteReportRow(rowData);
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </div>
                );
            }
        },
    ];

    return (
        <div>
            <OkDialog
                open={reportError != null}
                title={__t('error')}
                content={reportError}
                onClose={() => setReportError(null)}
            />
            <ConfirmDialog
                open={deleteReportRow != null}
                title={__t('delete_report')}
                content={deleteReportRow == null ? '' : deleteReportRow.completedDate == null ? __t('confirm_delete') : `${__t('report_delete_message')} ${toDateTimeString(stringToDate(deleteReportRow.completedDate.replace('T', ' '), jsonDateTimeFormat))}`}
                onClose={async (type) => {

                    try {
                        if (type == 'ok') {
                            setLoading(true);
                            await deleteReport(deleteReportRow.id);
                            setMessage({ isError: false, text: __t('success_deleting_report') })

                            setTimeout(() => {
                                props.fetchReports();

                                setLoading(false);
                            }, 1000);
                        }

                        setDeleteReportRow(null)
                    } catch (err) {
                        setLoading(false);

                        setMessage({ isError: true, text: __t('error_downloading_report') })
                        console.error('Error deleting report:', err);
                    }
                }}
            />
            <LoadingDialog loading={loading} />
            {props.filter != null ?
                <div style={{ fontStyle: 'italic' }}>
                    {__t('search')}: {props.filter.reportType == reportTypes.ALL_OFF_ROT ? __t('report_title_all_off_rot') : __t('report_title_all_off_mul')}, {toDateString(props.filter.fromDate)} - {toDateString(props.filter.toDate)}
                </div>
                :
                <div style={{ fontStyle: 'italic' }}>
                    {__t('reports_all')}
                </div>
            }
            <EMTable
                tableTitle={`${__t('reports')}`}
                rows={columnDefinition}
                dataSource={props.reports}
                // dataSource={[
                //     { id: '1', fromDate: '2021-01-01', toDate: '2021-01-31', insDate: '2021-02-01 10:15:55', insUser: 'User1', status: 'pending' },
                //     { id: '2', fromDate: '2021-02-01', toDate: '2021-02-28', insDate: '2021-03-01 15:59:05', insUser: 'User2', status: 'completed' },
                //     { id: '3', fromDate: '2021-02-01', toDate: '2021-02-29', insDate: '2021-03-01 15:29:05', insUser: 'User3', status: 'error' },
                // ]}
                filterComponent={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            style={{ size: 'small', marginLeft: '10px' }}
                            onClick={() => {
                                props.fetchReports();
                            }}
                        >
                            <RefreshIcon />
                        </IconButton>
                    </div>
                }
                customTableButton={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {props.filter != null ?
                            <Button
                                color={props.filter == null ? "secondary" : "primary"}
                                variant="outlined"
                                onClick={() => {
                                    console.log('generate report');

                                    setLoading(true);
                                    setLoadingGenerate(true);

                                    try {
                                        generateReport(props.filter.reportType, toDateJsonString(props.filter.fromDate), toDateJsonString(props.filter.toDate));
                                    } catch (error) {
                                        setMessage({ isError: true, text: __t('error_generating_report') })
                                        console.error('Error generating report:', error);
                                    }

                                    setLoadingGenerate(false);

                                    setTimeout(() => {
                                        props.fetchReports();
                                        setLoading(false);
                                    }, 2000);
                                }}
                                disabled={loadingGenerate}
                            >
                                {__t('generate')}
                                {loadingGenerate ?
                                    <CircularProgress style={{ marginLeft: '5px' }} size={20} />
                                    :
                                    null
                                }
                            </Button>
                            :
                            null
                        }
                    </div>
                }
            />
            {message != null ?
                <Snackbar
                    open={message != null}
                    autoHideDuration={5000}
                    onClose={() => setMessage(null)}
                >
                    {message == null ?
                        <SnackbarContent message={''} />
                        :
                        <SnackbarContent style={{ color: 'white', backgroundColor: message.isError ? 'red' : 'green' }} message={message.text} />
                    }
                </Snackbar>
                :
                null
            }
        </div>
    )
}

export default withStyles(styles)(ReportsPage);
